import React, { useRef, useState } from 'react';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, CircularProgress } from '@mui/material';
import cross from '../../Assets/Images/cross.svg';
import { useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { fetchDeployments, sendNotifications, createClientDeployment } from '../../api';
import Notification from '../Dashboard/Notification/Notification';
import Select from 'react-select';
import { validateName } from '../../utils/helper';

const AddClient = () => {

  // useNavigate and useContext
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  // useStates 
  const [isLoading, setIsLoading] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [existingEmails, setExistingEmails] = useState([]);
  const [otherTextBox, setOtherTextBox] = useState();
  const [titleMenuIsOpen, setTitleMenuIsOpen] = useState(false);
  const [industryMenuIsOpen, setIndustryMenuIsOpen] = useState(false);

  const inputStyles = { height: '50px', width: '400px', padding: '0 15px', fontSize: '18px', fontFamily: 'Lato, sans-serif', border: '1px solid #ccc', borderRadius: '4px', transition: 'border-color 0.2s ease', boxSizing: 'border-box', outline: 'none',
    ':focus': { borderColor: '#5795B2' }
  };
  const formContainerStyle = { display: 'flex', justifyContent: 'center', width: '100%', maxWidth: '830px', margin: '0 auto', alignItems: 'flex-start' };
  const formColumnStyle = { display: 'flex', flexDirection: 'column', gap: '20px', width: '400px', minHeight: '400px' };
  const formGapStyle = { width: '30px', flexShrink: 0 };
  const notificationRef = useRef(null);
  const titleSelectRef = useRef(null);
  const industrySelectRef = useRef(null);

  const titles = [
    { label: "Other", value: "Other" },
    { label: "CEO", value: "CEO" },
    { label: "CFO", value: "CFO" },
    { label: "COO", value: "COO" },
    { label: "Director", value: "Director" },
    { label: "HR/People Manager", value: "HR/People Manager" },
    { label: "Administrator", value: "Administrator" },
    { label: "Team/Department Manager", value: "Team/Department Manager" },
    { label: "Service/Customer Service Manager", value: "Service/Customer Service Manager" },
    { label: "Project Manager", value: "Project Manager" },
    { label: "Supervisor", value: "Supervisor" },
    { label: "Marketing/Sales Consultant", value: "Marketing/Sales Consultant" },
    { label: "Accounting/Finance", value: "Accounting/Finance" },
    { label: "Operations Manager", value: "Operations Manager" },
    { label: "Logistics/Supply Chain Coordinator", value: "Logistics/Supply Chain Coordinator" },
    { label: "Executive Assistant", value: "Executive Assistant" },
    { label: "Nonprofit Leader", value: "Nonprofit Leader" },
    { label: "Pastor/Religious Leader", value: "Pastor/Religious Leader" },
    { label: "Athlete/Coach", value: "Athlete/Coach" },
    { label: "Entrepreneur/Small Business Owner", value: "Entrepreneur/Small Business Owner" },
    { label: "Personal Development Seeker", value: "Personal Development Seeker" },
    { label: "Consultant", value: "Consultant" },
    { label: "Educator/Trainer", value: "Educator/Trainer" },
    { label: "Creative Professional", value: "Creative Professional" },
    { label: "Health/Wellness Professional", value: "Health/Wellness Professional" }
  ];

  const industries = [
    { label: "Agriculture", value: "Agriculture" },
    { label: "Automotive", value: "Automotive" },
    { label: "Construction", value: "Construction" },
    { label: "Education/Training", value: "Education/Training" },
    { label: "Energy/Utilities", value: "Energy/Utilities" },
    { label: "Engineering", value: "Engineering" },
    { label: "Entertainment/Media", value: "Entertainment/Media" },
    { label: "Finance/Banking", value: "Finance/Banking" },
    { label: "Government/Public Services", value: "Government/Public Services" },
    { label: "Healthcare/Medical", value: "Healthcare/Medical" },
    { label: "Hospitality/Tourism", value: "Hospitality/Tourism" },
    { label: "Information Technology (IT)", value: "Information Technology (IT)" },
    { label: "Insurance", value: "Insurance" },
    { label: "Leadership Development/Consulting", value: "Leadership Development/Consulting" },
    { label: "Legal Services", value: "Legal Services" },
    { label: "Manufacturing/Production", value: "Manufacturing/Production" },
    { label: "Marketing/Advertising", value: "Marketing/Advertising" },
    { label: "Non-Profit/Charity/Churches", value: "Non-Profit/Charity/Churches" },
    { label: "Real Estate/Property", value: "Real Estate/Property" },
    { label: "Transportation/Logistics", value: "Transportation/Logistics" }
  ];

  const groupIDs = [
    { label: 'e.g. Simon123', value: '' },
    { label: 'Group 1', value: 'group1' },
    { label: 'Group 2', value: 'group2' },
    { label: 'Group 3', value: 'group3' },
  ];

  const [formValues, setFormValues] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    title: '',
    type_text: '',
    company: '',
    industry: '',
    groupID: '',
  });

  const [errors, setErrors] = useState({
    firstnameError: '',
    lastnameError: '',
    emailError: '',
    phoneError: '',
    titleError: '',
    typedTitleError: '',
    companyError: '',
    industryError: '',
    groupIDError: ''
  });

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: '50px !important', minHeight: '50px !important', width: '400px !important', border: state.isFocused ? '1px solid #5795B2' : '1px solid #ccc', borderRadius: '4px', boxShadow: 'none !important', transition: 'border-color 0.2s ease', fontSize: '18px', fontFamily: 'Lato, sans-serif', cursor: 'pointer',
      '&:hover': {
        borderColor: state.isFocused ? '#5795B2' : '#aaa', 
      },
      '&:focus-within': {
        borderColor: '#5795B2',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '48px !important', padding: '0 15px !important', display: 'flex', alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px !important', height: 'auto', fontSize: '18px', fontFamily: 'Lato, sans-serif',
    }),
    placeholder: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif', color: '#C7C7C7', fontSize: '18px', lineHeight: '21.6px', fontWeight: 400, margin: '0px',
    }),
    singleValue: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif', color: '#303030', fontSize: '18px', lineHeight: '21.6px', fontWeight: 400, margin: '0px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      padding: '8px', color: '#666', cursor: 'pointer', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: '10px',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#426B88' : state.isFocused ? '#DDEAF0' : 'white', color: state.isSelected ? 'white' : '#303030', fontFamily: 'Lato, sans-serif', fontSize: '16px', cursor: 'pointer', padding: '10px 15px',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validNameRegex = /^[a-zA-Z\s.''\-]{2,}$/;
  const validPhoneRegex = /^\d{10}$/;

  const formatPhoneNumber = (value) => {
    let cleaned = value.replace(/\D/g, "");
    let formatted = "";
    if (cleaned.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length > 3) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned.length > 0) {
      formatted = `(${cleaned}`;
    }

    return formatted;
  };

  const extractNumber = (number) => number.replace(/\D/g, "");

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };

    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isNotificationOpen]);

  useEffect(() => {
    const fetchExistingClients = async () => {
      try {
        const clients = await fetchDeployments(authCtx);
        // console.log('existingClients', clients)
        const emails = clients.map(client => {
          const emailProp = client?.email;
          // console.log('emailProp', emailProp)
          return emailProp
        }).filter(Boolean);
        setExistingEmails(emails);
        // console.log('existingEmails', existingEmails)
      } catch (error) {
        // console.error("Failed to fetch existing clients:", error);
      }
    };

    fetchExistingClients();
  }, []);

  // Add CSS styles for input focus
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .client-input:focus { border-color: #5795B2 !important; outline: none !important; }
      .title-type-text input:focus { border-color: #5795B2 !important; outline: none !important; }
      .client-info { min-height: 70px; display: flex; flex-direction: column; }
      .client-info .form-error { margin-top: 3px; min-height: 18px; display: block; font-size: 14px; }
      .form-column-container { display: flex; justify-content: space-between; width: 100%; max-width: 830px; margin: 0 auto; gap: 30px; }
      .form-column { flex: 1; display: flex; flex-direction: column; width: 400px; }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  const handleSelectChange = (selectedOption, fieldName) => {
    // console.log('Selected option:', selectedOption, 'for field:', fieldName);
    const value = selectedOption ? selectedOption.value : '';
    if (fieldName === 'title') {
      setFormValues((prev) => ({
        ...prev,
        [fieldName]: value,
        type_text: value === 'Other' ? prev.type_text : ''
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }

    if (fieldName === 'title') {
      setErrors((prev) => ({
        ...prev,
        titleError: '',
        typedTitleError: ''
      }));
      
      setTimeout(() => {
        setTitleMenuIsOpen(false);
      }, 100);
      
      if (value === 'Other') {
        setTimeout(() => {
          const input = document.querySelector('.title-type-text input');
          if (input) input.focus();
        }, 200);
      }
    } else if (fieldName === 'industry') {
      setErrors((prev) => ({
        ...prev,
        industryError: '',
      }));
      
      setTimeout(() => {
        setIndustryMenuIsOpen(false);
      }, 100);
    }
  };

  const handleMenuOpen = (fieldName) => {
    if (fieldName === 'title') {
      setTitleMenuIsOpen(true);
    } else if (fieldName === 'industry') {
      setIndustryMenuIsOpen(true);
    }
  };

  const handleMenuClose = (fieldName) => {
    setTimeout(() => {
      if (fieldName === 'title') {
        setTitleMenuIsOpen(false);
      } else if (fieldName === 'industry') {
        setIndustryMenuIsOpen(false);
      }
    }, 150);
  };

  const handleDropdownIndicatorClick = (fieldName) => {
    if (fieldName === 'title') {
      setTitleMenuIsOpen(!titleMenuIsOpen);
    } else if (fieldName === 'industry') {
      setIndustryMenuIsOpen(!industryMenuIsOpen);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    // console.log("name,value", name, value)
    if (name === 'phone') {
      setFormValues({ ...formValues, [name]: formatPhoneNumber(value) });
    }
    else {
      setFormValues({ ...formValues, [name]: value });
    }

    switch (name) {
      case 'firstname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, firstnameError: 'Please enter a valid first name.' }));
        } else {
          const firstNameError = validateName(value);
          if (firstNameError && firstNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, firstnameError: firstNameError }));
          } else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, firstnameError: 'Please enter a valid first name.' }));
          } else {
            setErrors(prev => ({ ...prev, firstnameError: '' }));
          }
        }
        break;
      case 'lastname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, lastnameError: 'Please enter a valid last name.' }));
        } else {
          const lastNameError = validateName(value);
          if (lastNameError && lastNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, lastnameError: lastNameError }));
          }  else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, lastnameError: 'Please enter a valid last name.' }));
          }else {
            setErrors(prev => ({ ...prev, lastnameError: '' }));
          }
        }
        break;
      case 'email':
        setErrors(prev => ({ ...prev, emailError: !emailRegex.test(value) ? 'Please enter a valid email address.' : '' }));
        break;
      case 'phone':
        setErrors(prev => ({ ...prev, phoneError: !validPhoneRegex.test(extractNumber(value)) ? 'Please enter a valid phone number.' : '' }));
        break;
      case 'title':
        setErrors(prev => ({ ...prev, titleError: value.trim() === '' ? 'Please select/enter your title.' : '' }));
        break;
      case 'type_text':
        setErrors(prev => ({ ...prev, typedTitleError: value.trim() === '' ? 'Please enter your title.' : '' }));
        break;
      case 'company':
        setErrors(prev => ({ ...prev, companyError: value.trim() === '' ? 'Please enter your company name.' : '' }));
        break;
      case 'industry':
        setErrors(prev => ({ ...prev, industryError: value.trim() === '' ? 'Please select/enter your industry.' : '' }));
        break;
      case 'groupID':
        setErrors(prev => ({ ...prev, groupIDError: '' }));
        break;
      default:
        break;
    }
  };

  
  const clientData = JSON.parse(localStorage.getItem("clientData"));

  // console.log('clientData', clientData.id)
 
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (existingEmails.includes(formValues.email.toLowerCase())) {
      setErrors(prev => ({ ...prev, emailError: 'This email is already used by another client.' }));
      return;
    }

    if (validateForm()) {
      setIsLoading(true)
      const data = {
        title: formValues?.title == "Other" ? formValues?.type_text : formValues?.title,
        properties: [
          { property: "email", value: formValues?.email },
          { property: "name", value: formValues?.firstname + " " + formValues?.lastname },
          { property: "firstName", value: formValues?.firstname },
          { property: "lastName", value: formValues?.lastname },
          { property: "industry", value: formValues?.industry },
          { property: "phone", value: extractNumber(formValues?.phone) },
          { property: "company", value: formValues?.company },
          { property: "groupid", value: formValues?.groupID?.trim() || "-" },
          { property: "url", value: formValues?.url || "" },
          { property: "started", value: formValues?.started || new Date() }
        ]
      };

      const requestBody = {
        assessmentId: 78,
        title: data.title,
        properties: data.properties
      };

      try {
        const response = await createClientDeployment(requestBody, authCtx);

        if (response.status === "success") {
          setIsLoading(false);
          // console.log('Client added successfully:', response);

          const sendNotificationsHelper = async () => {
            await sendNotifications({
              action: "client_added",
              action_link: "/clients",
              msg: "<Full Name> has been added as a client:",
              user_name: formValues?.firstname+" "+formValues?.lastname,
              type: "client_added",
              orgId: authCtx?.orgId,
              clientId: response?.deploymentId,
              asmtId: clientData?.id
            });
          }
          sendNotificationsHelper()
            fetchDeployments(authCtx)
              .then(updatedClientData => {
                const newlyCreatedClient = updatedClientData.find(client => client.id === response?.deploymentId);
                // console.log("Newly created client:", newlyCreatedClient);
                localStorage.setItem("clientData", JSON.stringify(newlyCreatedClient));
                navigate(`/added-client/${response.deploymentId}?isNew=true`, {
                  state: { client: newlyCreatedClient || response }
                });

              })
              .catch(error => {
                // console.error('Error fetching updated deployments:', error);              
                navigate(`/added-client/${response.deploymentId}?isNew=true`, {
                  state: { client: response }
                });
              });
          } else {
            setIsLoading(false);
            // console.error('Error adding client:', response);
        }
        } catch (error) {
          setIsLoading(false);
          // console.error('Error:', error);
        }
      }
    };

  const handelCross = () => {
    const storedClients = localStorage.getItem('clients');
    if (storedClients) {
      navigate('/added-clients');
    } else {
      navigate(-1);
    }
  }

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!validNameRegex.test(formValues.firstname) || formValues.firstname.trim() === '') {
      newErrors.firstnameError = 'Please enter a valid first name.';
      valid = false;
    } else {
      const firstNameError = validateName(formValues.firstname);
      if (firstNameError && firstNameError !== 'Please enter a valid name.') {
        newErrors.firstnameError = firstNameError;
        valid = false;
      }
    }
    
    if (!validNameRegex.test(formValues.lastname) || formValues.lastname.trim() === '') {
      newErrors.lastnameError = 'Please enter a valid last name.';
      valid = false;
    } else {
      const lastNameError = validateName(formValues.lastname);
      if (lastNameError && lastNameError !== 'Please enter a valid name.') {
        newErrors.lastnameError = lastNameError;
        valid = false;
      }
    }
    if (!emailRegex.test(formValues.email)) {
      newErrors.emailError = 'Please enter a valid email address.';
      valid = false;
    }
    if (!validPhoneRegex.test(extractNumber(formValues.phone))) {
      newErrors.phoneError = 'Please enter a valid phone number.';
      valid = false;
    }
    if (formValues.title.trim() === '') {
      newErrors.titleError = 'Please select/enter your title.';
      valid = false;
    } else if (formValues.title === 'Other' && formValues.type_text.trim() === '') {
      newErrors.typedTitleError = 'Please enter your title.';
      valid = false;
    }

    if (formValues.company.trim() === '') {
      newErrors.companyError = 'Please enter your company name.';
      valid = false;
    }
    if (formValues.industry.trim() === '') {
      newErrors.industryError = 'Please select/enter your industry.';
      valid = false;
    }
    
    // Group ID is optional - no validation required
    // if (formValues.groupID.trim() === '') {
    //   newErrors.groupIDError = 'Please enter group ID.';
    //   valid = false;
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCross = () => {
    const storedClients = localStorage.getItem('clients');
    if (storedClients) {
      navigate('/added-clients');
    } else {
      navigate(-1);
    }
  };

  const handleNotificationOpen = () => {
    setIsNotificationOpen(true);
  }
  const handleNotificationClose = () => {
    setIsNotificationOpen(false);
  };

  return (
    <div className='dashboard-platform'>
      <DashboardHeader heading='Clients' handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />

      <div className='dashboard-container'>
        <p className='page-name'>{`Clients > `}<span className='add-client'>{`Add client`}</span></p>
        <div className="client-detail">
          <div className="cross">
            <img src={cross} alt="cross" className='cross-image' onClick={handleCross} />
          </div>
          <h2 className='client-heading'>Fill in these details to add a client </h2>
          <form className="client-form" onSubmit={handleSubmit}>
            <div className="form-column-container">
              <div className="form-column">
                <div className={`client-info ${errors.firstnameError ? 'error' : ''}`}>
                  <p className='client-info-p'>First Name<span className="asterisk-mark">*</span></p>
                  <input type="text" name="firstname" className='client-input' placeholder='e.g. Simon' value={formValues.firstname} onChange={handleChange} required style={inputStyles} />
                  <div className="form-error">{errors.firstnameError}</div>
                </div>
                <div className={`client-info ${errors.emailError ? 'error' : ''}`}>
                  <p className='client-info-p'>Email<span className="asterisk-mark">*</span></p>
                  <input type="email" name='email' className='client-input' placeholder='e.g. simonpeter@petra.org' value={formValues.email} onChange={handleChange} required style={inputStyles} />
                  <div className="form-error">{errors.emailError}</div>
                </div>
                <div className={`client-info ${errors.titleError ? 'error' : ''}`}>
                  <p className='client-info-p'>Title<span className="asterisk-mark">*</span></p>
                  {
                    formValues.title === "Other" ? 
                    <>
                      <div className='title-type-text'>
                        <input type="text" name="type_text" className='client-input' placeholder='Start typing' value={formValues.type_text} onChange={handleChange} required style={inputStyles} autoComplete="off" spellCheck="false" />
                        <Button className='close-btn-typed-text' onClick={() => { setFormValues({ ...formValues, "title": "", "type_text": "" }) }} >
                          <img src={cross} alt="cross" className='cross-image' />
                        </Button>
                      </div>
                      <div className="form-error">{errors.typedTitleError}</div>
                    </>
                    :
                    <>
                      <div style={{ width: '100%' }}>
                        <div style={{ position: 'relative' }}>
                          <Select 
                            ref={titleSelectRef} 
                            name="title" 
                            placeholder="Select/type your title" 
                            value={formValues.title ? titles.find(option => option.value === formValues.title) : null} 
                            onChange={(selectedOption) => { 
                              // console.log('Title selected:', selectedOption); 
                             handleSelectChange(selectedOption, 'title'); }} 
                            onMenuOpen={() => handleMenuOpen('title')} 
                            onMenuClose={() => handleMenuClose('title')} 
                            required 
                            styles={customStyles} 
                            options={titles} 
                            isSearchable={true} 
                            className="react-select-container" 
                            classNamePrefix="react-select" 
                            menuPortalTarget={document.body} 
                            menuPosition={'fixed'} 
                            menuIsOpen={titleMenuIsOpen} 
                            openMenuOnFocus={false} 
                            openMenuOnClick={true} 
                            closeMenuOnSelect={true} 
                            blurInputOnSelect={true}
                            filterOption={(option, inputValue) => {
                              return option.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                            components={{
                              DropdownIndicator: (props) => (
                                <div {...props.innerProps} onClick={(e) => { e.stopPropagation(); handleDropdownIndicatorClick('title'); }}
                                  style={{ padding: '8px', color: '#666', cursor: 'pointer', transform: titleMenuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', display: 'flex', alignItems: 'center' }} >
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                  </svg>
                                </div>
                              )
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-error">{errors.titleError}</div>
                    </>
                  }
                </div>
                <div className={`client-info ${errors.industryError ? 'error' : ''}`}>
                  <p className='client-info-p'>Industry<span className="asterisk-mark">*</span></p>
                  <div style={{ width: '100%' }}>
                    <div style={{ position: 'relative' }}>
                      <Select ref={industrySelectRef} name="industry" placeholder="Select your industry" value={formValues.industry ? industries.find(option => option.value === formValues.industry) : null}
                        onChange={(selectedOption) => { handleSelectChange(selectedOption, 'industry'); }}
                        onMenuOpen={() => handleMenuOpen('industry')} onMenuClose={() => handleMenuClose('industry')} required styles={customStyles} options={industries} isSearchable={true} className="react-select-container" classNamePrefix="react-select" menuPortalTarget={document.body} menuPosition={'fixed'} menuIsOpen={industryMenuIsOpen} openMenuOnFocus={false} openMenuOnClick={true} closeMenuOnSelect={true} blurInputOnSelect={true}
                        components={{
                          DropdownIndicator: (props) => (
                            <div
                              {...props.innerProps}
                              onClick={(e) => { e.stopPropagation(); handleDropdownIndicatorClick('industry'); }}
                              style={{ padding: '8px', color: '#666', cursor: 'pointer', transform: industryMenuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', display: 'flex', alignItems: 'center' }}
                            >
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                              </svg>
                            </div>
                          )
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-error">{errors.industryError}</div>
                </div>
              </div>

              <div className="form-column">
                <div className={`client-info ${errors.lastnameError ? 'error' : ''}`}>
                  <p className='client-info-p'>Last Name<span className="asterisk-mark">*</span></p>
                  <input type="text" name="lastname" className='client-input' placeholder='e.g. Peter' value={formValues.lastname} onChange={handleChange} required style={inputStyles} />
                  <div className="form-error">{errors.lastnameError}</div>
                </div>
                <div className={`client-info ${errors.phoneError ? 'error' : ''}`}>
                  <p className='client-info-p'>Phone<span className="asterisk-mark">*</span></p>
                  <input type="text" name="phone" className='client-input' placeholder='e.g. (555) 123-4567' value={formValues.phone} onChange={handleChange} required style={inputStyles} />
                  <div className="form-error">{errors.phoneError}</div>
                </div>
                <div className={`client-info ${errors.companyError ? 'error' : ''}`}>
                  <p className='client-info-p'>Company<span className="asterisk-mark">*</span></p>
                  <input type="text" name="company" className='client-input' placeholder='Type your company&apos;s name' value={formValues.company} onChange={handleChange} required style={inputStyles} />
                  <div className="form-error">{errors.companyError}</div>
                </div>
                <div className={`client-info ${errors.groupIDError ? 'error' : ''}`}>
                  <p className='client-info-p'>Group ID</p>
                  <input type="text" name="groupID" className='client-input' placeholder='e.g. Simon123 (optional)' value={formValues.groupID} onChange={handleChange} style={inputStyles} />
                  <div className="form-error">{errors.groupIDError}</div>
                </div>
              </div>
            </div>
          </form>
          <div className='client-cta'>
            {isLoading ? <Button className='client-button' disabled >{<CircularProgress size={20} style={{ color: "#fff" }} />}</Button> : <Button className='client-button' type="submit" onClick={handleSubmit}>Add a Client</Button>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddClient;
